export default "__VITE_ASSET__CDTqDrsD__"